import { type FC, type SVGProps } from 'react';

const FacebookIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg
		height="40px"
		version="1.1"
		viewBox="0 0 40 40"
		width="40px"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		{...props}
	>
		<title>icon_facebook-grey_40x40</title>
		<defs></defs>
		<g
			fill="none"
			fillRule="evenodd"
			id="Full-pages"
			stroke="none"
			strokeWidth="1"
		>
			<g
				fill="#9dafbd"
				id="1280px-and-wider-(popular-desktop)"
				transform="translate(-828.000000, -2617.000000)"
			>
				<g id="Group-2" transform="translate(-1.000000, 2304.000000)">
					<path
						d="M849,353 C837.954305,353 829,344.045695 829,333 C829,321.954305 837.954305,313 849,313 C860.045695,313 869,321.954305 869,333 C869,344.045695 860.045695,353 849,353 Z M854.355469,325.629721 L854.355469,322.004762 L851.35616,322 C848.388353,322 846.356457,323.811747 846.356457,327.138166 L846.356457,330.004507 L843,330.004507 L843,333.89174 L846.356457,333.89174 L846.356457,343.866237 L850.370798,343.866237 L850.370798,333.89174 L854.218471,333.89174 L854.219569,330.004507 L850.370798,330.004507 L850.370798,327.522787 C850.370798,326.397497 850.683623,325.630453 852.297198,325.630453 L854.355469,325.629721 Z"
						id="icon_facebook-grey_40x40"
					></path>
				</g>
			</g>
		</g>
	</svg>
);

const InstagramIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg
		height="40"
		viewBox="0 0 40 40"
		width="40"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20zm5.23-7A6.778 6.778 0 0 0 32 26.23V14.77A6.778 6.778 0 0 0 25.23 8H13.77A6.778 6.778 0 0 0 7 14.77v11.46A6.778 6.778 0 0 0 13.77 33h11.46zM13.77 10.083h11.46a4.693 4.693 0 0 1 4.687 4.688v11.458a4.693 4.693 0 0 1-4.688 4.688H13.771a4.693 4.693 0 0 1-4.688-4.688V14.771a4.693 4.693 0 0 1 4.688-4.688zM19.5 26.75a6.257 6.257 0 0 0 6.25-6.25 6.257 6.257 0 0 0-6.25-6.25 6.257 6.257 0 0 0-6.25 6.25 6.257 6.257 0 0 0 6.25 6.25zm0-10.417a4.171 4.171 0 0 1 4.167 4.167 4.171 4.171 0 0 1-4.167 4.167 4.171 4.171 0 0 1-4.167-4.167 4.171 4.171 0 0 1 4.167-4.167zm6.64-1.041a1.432 1.432 0 1 0 0-2.865 1.432 1.432 0 0 0 0 2.865z"
			fill="#9dafbd"
			fillRule="evenodd"
		/>
	</svg>
);

const XIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg
		height="40px"
		version="1.1"
		viewBox="0 0 40 40"
		width="40px"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		{...props}
	>
		<g id="surface1">
			<path
				d="M 17.867188 0.148438 C 10.839844 0.878906 4.558594 5.507812 1.707031 12.054688 C -0.132812 16.28125 -0.441406 21.148438 0.867188 25.625 C 2.480469 31.214844 6.652344 35.933594 12.054688 38.292969 C 16.28125 40.132812 21.148438 40.4375 25.628906 39.132812 C 32.332031 37.199219 37.613281 31.695312 39.347656 24.851562 C 42.054688 14.132812 35.414062 3.171875 24.667969 0.613281 C 22.304688 0.0546875 20.226562 -0.09375 17.867188 0.148438 Z M 18.132812 12.535156 C 19.839844 14.800781 21.28125 16.667969 21.332031 16.667969 C 21.386719 16.667969 23.160156 14.800781 25.253906 12.535156 L 29.078125 8.398438 L 31.253906 8.398438 L 30.785156 8.894531 C 30.519531 9.171875 28.785156 11.054688 26.933594 13.066406 C 25.078125 15.078125 23.265625 17.039062 22.90625 17.398438 L 22.265625 18.078125 L 27.265625 24.734375 C 30.011719 28.398438 32.265625 31.441406 32.265625 31.492188 C 32.265625 31.558594 30.628906 31.601562 28.640625 31.601562 L 25 31.585938 L 21.613281 27.054688 C 19.28125 23.921875 18.1875 22.574219 18.078125 22.652344 C 18 22.71875 16.105469 24.761719 13.867188 27.1875 L 9.800781 31.601562 L 8.773438 31.601562 C 8.199219 31.601562 7.734375 31.574219 7.734375 31.535156 C 7.734375 31.492188 9.851562 29.171875 12.441406 26.386719 C 15.011719 23.601562 17.148438 21.265625 17.171875 21.226562 C 17.1875 21.171875 15.066406 18.28125 12.464844 14.800781 C 9.867188 11.332031 7.734375 8.464844 7.734375 8.441406 C 7.734375 8.414062 9.371094 8.398438 11.386719 8.398438 L 15.039062 8.398438 Z M 18.132812 12.535156 "
				style={{
					stroke: 'none',
					fillRule: 'nonzero',
					fill: 'rgb(61.568627%,68.627451%,74.117647%)',
					fillOpacity: 1,
				}}
			/>
			<path
				d="M 11.027344 10.1875 C 11.082031 10.28125 14.441406 14.785156 18.464844 20.171875 L 25.800781 29.988281 L 27.441406 30 C 28.453125 30 29.066406 29.945312 29.039062 29.867188 C 29.027344 29.800781 25.679688 25.292969 21.628906 19.867188 L 14.238281 10 L 12.585938 10 C 11.214844 10 10.933594 10.027344 11.027344 10.1875 Z M 11.027344 10.1875 "
				style={{
					stroke: 'none',
					fillRule: 'nonzero',
					fill: 'rgb(0%,0%,0%)',
					fillOpacity: 1,
				}}
			/>
		</g>
	</svg>
);

export const socialLinks = [
	{
		name: 'facebook',
		SvgIcon: FacebookIcon,
		linkLabel: 'CX_SOCIAL_FACEBOOK_ACCOUNT',
	},
	{
		name: 'instagram',
		SvgIcon: InstagramIcon,
		linkLabel: 'CX_SOCIAL_INSTAGRAM_ACCOUNT',
	},
	{
		name: 'x',
		SvgIcon: XIcon,
		linkLabel: 'CX_SOCIAL_X_ACCOUNT',
	},
];
